import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { FabHold, ListItem, RepositoryModal } from '../../shared'

export interface FabHoldModalParent {
    pieceOptions: ListItem<string>[]
    reasonOptions: ListItem<string>[]
    stepOptions: ListItem<string>[]
    userList: ListItem<string>[]
}

@Component({
    templateUrl: './fab-hold.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class FabHoldComponent extends RepositoryModal<FabHold> {
    pieceOptions: ListItem<string>[] = []
    reasonOptions: ListItem<string>[] = []
    stepOptions: ListItem<string>[] = []
    userList: ListItem<string>[] = []

    protected onInitialized(): void {
        const parent = this.editOptions.initializeParams as FabHoldModalParent
        this.pieceOptions = parent?.pieceOptions ?? []
        this.reasonOptions = parent?.reasonOptions ?? []
        this.stepOptions = [new ListItem(null as unknown as string, '(Any step)'), ...(parent?.stepOptions ?? [])]
        this.userList = [new ListItem(null as unknown as string, '(Unassigned)'), ...(parent?.userList ?? [])]

        if (this.isAdding || this.isDuplicating) {
            if (!this.target.id) this.target.id = crypto.randomUUID()
            if (!this.target.startedOn) this.target.startedOn = new Date()
            this.target.isOpen = true
            this.target.daysHeld = 0
            // Wijmo shows the first combo item without writing it onto the model.
            if (!this.target.fabPieceId && this.pieceOptions.length) {
                this.target.fabPieceId = this.pieceOptions[0].value
            }
            if (!this.target.fabHoldReasonId && this.reasonOptions.length) {
                this.target.fabHoldReasonId = this.reasonOptions[0].value
            }
            if (!this.target.fabProcessStepId) this.target.fabProcessStepId = null
            if (!this.target.ownerUserId) this.target.ownerUserId = null
        }
    }
}
